import { useConfig } from "../../context/config-context";

const DeviceCard = ({
  patient,
  pump,
  devices,
  lastIntervention,
  className,
}) => {
  const siteConfig = useConfig();
  const deviceConfig = siteConfig.components.device_card;

  return (
    <div
      className={`shadow-xl rounded-xl h-fit${
        className ? " " + className : ""
      }`}
    >
      <div className="p-2 px-3 font-semibold text-white bg-primary rounded-t-xl">
        <label className="uppercase">{deviceConfig.label}</label>
      </div>
      <div className="bg-white p-3 rounded-b-xl flex flex-col gap-1 min-h-[50px]">
        {pump || devices.length ? (
          <span className="flex flex-col gap-2">
            {deviceConfig.data.map((item, index) => (
              <div key={index}>
                <label className="font-semibold">{item.label} : </label>
                <span>
                  {item.formatter({
                    value: pump
                      ? pump[item.value]
                      : devices.length
                      ? devices[0][item.value]
                      : null,
                    unit: item.unit,
                    removeText: item.removeText,
                    key: item.key,
                  })}
                </span>
              </div>
            ))}
            {deviceConfig.dataIntervention.map((item, index) => (
              <div key={index}>
                <label className="font-semibold">{item.label} : </label>
                <span>
                  {item.formatter({
                    value: lastIntervention
                      ? lastIntervention[item.value]
                      : null,
                    removeText: item.removeText,
                    unit: item.unit,
                    key: item.key,
                  })}
                </span>
              </div>
            ))}
            {deviceConfig.dataPatient.map((item, index) => (
              <div key={index}>
                <label className="font-semibold">{item.label} : </label>
                <span>
                  {item.formatter({
                    value: patient ? patient[item.value] : null,
                    removeText: item.removeText,
                    unit: item.unit,
                    key: item.key,
                  })}
                </span>
              </div>
            ))}
          </span>
        ) : (
          <p className="font-semibold text-center">{deviceConfig.none}</p>
        )}
      </div>
    </div>
  );
};

export default DeviceCard;
